<mat-accordion multi>
    <ng-content select="[header]"></ng-content>
    @for (item of lists; track item) {
        <div class="d-flex flex-column gap-3">
            <ng-content></ng-content>
        </div>
    }
</mat-accordion>
